<template>
  <b-card class="no-border mt-3" no-body>
    <vehicle-table />
  </b-card>
</template>
<script>
import VehicleTable from '@/components/VehicleTable.vue';

export default {
  name: 'vehicle_list',
  components: {
    VehicleTable,
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'vehicles', name: 'Vehicles' },
    ]);
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/admin/vehicles/List.vue